import React, { memo } from 'react';
import { Image, View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { ListItem } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { useMoneyMask } from '@redlink/core';
import { InnerLinkList } from '@redlink/components/muscles';

export const ProductItem = memo(
  ({
    item: {
      code,
      images,
      title,
      price,
      discount,
      isAvailable,
      totalHit,
      totalView,
      shortLinkUrl,
      isVisible,
      links = [],
    } = {},
    onEditPressed,
    onCopyPressed,
    onChangeAvailability,
    onDelete,
  }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    const { getValue } = useMoneyMask();
    const finalPrice = price - discount;
    const finalPriceText = `${getValue(finalPrice)} ${dictionary.moneyPostfix}`;
    const priceText = `${getValue(price)} ${dictionary.moneyPostfix}`;
    return (
      <ListItem
        FooterComponent={<InnerLinkList data={links} />}
        showCopy
        {...{
          isVisible,
          totalHit,
          totalView,
          onEditPressed,
          onCopyPressed,
          onChangeAvailability,
          onDelete,
        }}
      >
        <Image source={{ uri: images[0]?.thumbnailUrl }} style={styles.image} />
        <Space size={16} />
        <View>
          <Text style={styles.titleText}>{title}</Text>
          <View style={styles.pricesContainer}>
            <Text style={styles.finalPriceText}>{finalPriceText}</Text>
            <Space />
            <Text style={styles.priceText}>{priceText}</Text>
          </View>
        </View>
      </ListItem>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  image: {
    width: 50,
    height: 50,
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.gray23,
    textAlign: 'left',
  },
  subtitleText: {
    fontSize: 12,
    color: colors.gray23,
  },
  pricesContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  finalPriceText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: colors.gray23,
  },
  priceText: {
    fontSize: 12,
    color: colors.gray23,
  },
}));
